import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.8128 13.3319V11.9617C18.8128 11.205 18.1993 10.5915 17.4426 10.5915H3.74045C2.9837 10.5915 2.37024 11.205 2.37024 11.9617V20.183C2.37024 20.9397 2.9837 21.5532 3.74045 21.5532H17.4426C18.1993 21.5532 18.8128 20.9397 18.8128 20.183V18.8128M18.8128 13.3319H13.3319C11.8184 13.3319 10.5915 14.5588 10.5915 16.0723C10.5915 17.5858 11.8184 18.8128 13.3319 18.8128H18.8128M18.8128 13.3319C20.3263 13.3319 21.5532 14.5588 21.5532 16.0723C21.5532 17.5858 20.3263 18.8128 18.8128 18.8128M6.48088 10.5915V6.48085C6.48088 4.2106 8.32127 2.37021 10.5915 2.37021C12.8618 2.37021 14.7022 4.2106 14.7022 6.48085V10.5915M18.1277 16.0723H19.4979M15.3873 16.0723H16.7575M12.6468 16.0723H14.017",
  stroke: "currentColor",
  "stroke-width": "1.37021"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LockIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "lock",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})